<div class="modal-content">
  <div class="modal-header">
    <h4><strong> {{ heading }} </strong></h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clicked(false)">
      <fa-icon [icon]="['far', 'times-circle']" size="lg">  </fa-icon>
    </button>
  </div>
  <div class="modal-body our-form-background">
    <div [innerHTML]="question"></div>
  </div>
  <div class="modal-footer">
    <div>
      <button type="button" p-button class="relative waves-light eca-btn"
              [ngClass]="'eca-btn-' + noButtonColour" (click)="clicked(false)">
        <span>{{ noButtonText }}</span> <fa-icon style="margin-left: 10px" [icon]="noButtonIcon" size="lg" *ngIf="noButtonIcon"></fa-icon>
      </button>
      <button type="button" *ngIf="(yesButtonText || yesButtonIcon)"
              p-button
              [ngClass]="'eca-btn-' + yesButtonColour"
              class="relative waves-light eca-btn"
              (click)="clicked(true)">
        <span>{{ yesButtonText }}</span> <fa-icon style="margin-left: 10px" [icon]="yesButtonIcon" size="lg" *ngIf="yesButtonIcon"></fa-icon>
      </button>
    </div>
  </div>
</div>
